export default "__VITE_ASSET__1NsJH2W___"